import { z } from 'zod';
import { TDetailedErrorResponse } from 'src_server/trpc/types/error';

export const InputSchema = z.object({
    username: z.string(),
    receivedVia: z.string(),
    tokenValue: z.string(),
});

export type AccountRequestPasswordResetValidateInput = z.infer<typeof InputSchema>;

export const SuccessResponseSchema = z.object({
    status: z.number(),
    bodyJson: z.object({
        valid: z.boolean(),
        attempts: z.number(),
    }),
});

export type SuccessResponseType = z.infer<typeof SuccessResponseSchema>;

export const AccountNotFoundErrorResponse = z.object({
    status: z.number(),
    bodyJson: z.object({
        code: z.literal('account-not-found'),
        message: z.string(),
    }),
});

export type AccountNotFoundErrorResponseType = z.infer<typeof AccountNotFoundErrorResponse>;

export type TResponseType =
    | { responseStatus: 'success'; data: SuccessResponseType }
    | { responseStatus: 'error'; data: TDetailedErrorResponse };
